import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, concatMap, tap } from 'rxjs/operators';
import { AuditsService } from 'src/app/modules/audits/services/audits.service';
import { IGlimpseNewReport } from 'src/app/modules/customer-shared/models/IGlimpseNewReport';
import { IGlimpseReport } from 'src/app/modules/customer-shared/models/IGlimpseReport';
import { TrackingService } from 'src/app/modules/shared/services/tracking.service';
import * as fromActions from './audits.actions';
import * as fromEvents from "../../modules/audits/tracking/events";

@Injectable()
export class AuditsEffects {
  constructor(
    private actions$: Actions,
    private reports: AuditsService,
    private tracking: TrackingService,
  ) {}

  loadReports$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadReports),
      concatMap(action =>
        this.reports.getNewReports(action.locationId).pipe(
          map(reports =>
            fromActions.loadReportsSuccess({
              latestReports: this.transform(reports),
              locationId: action.locationId,
            }),
          ),
          tap(_ => this.tracking.track(fromEvents.loadReportsEvent())),
        ),
      ),
    ),
  );

  private transform(cards: IGlimpseNewReport[]): IGlimpseReport[] {
    const reports: IGlimpseReport[] = [];
    for (const customer of cards) {
      for (const location of customer.locations) {
        for (const area of location.areas) {
          reports.push({
            ...area.reports[0],
            trends: area.trends,
            settings: {
              start: area.reports[0].start,
              end: area.reports[0].end,
              sopPost: 0,
              sopPre: 0,
              time: area.reports[0].time,
              updated: '',
            },
            items: area.reports[0].itemsDetail,
            sections: [],
          });
        }
      }
    }
    return reports;
  }
}
